import { Typography } from '@mui/material';
import ProductTourContent from 'src/components/ProductTourContent';
import { IProductTour } from 'src/models/productTour';

export const FirstTimeTour: IProductTour = {
  title: 'Welcome to Dashboard',
  menu: 'first_time',
  submenu: 'first_time',
  steps: [
    {
      title: 'Welcome to NoLimit Dashboard 👋',
      content: (
        <ProductTourContent alignItems="center" spacing={1} direction="row">
          Let's take a quick look around and explore what you can do.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: "Let's get started"
    },
    {
      title: 'Overall Data Initialization Progress',
      content: (
        <ProductTourContent alignItems="center" spacing={1} direction="row">
          Check the overall progress of the data you've submitted to the
          dashboard.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'List Activity',
      content: (
        <ProductTourContent alignItems="center" spacing={1} direction="row">
          Click here to view all activity progress, including data details,
          labeling, sentiment changes, clipping, and downloads.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Track Your Data Preparation',
      content: (
        <ProductTourContent alignItems="center" spacing={1} direction="row">
          <Typography fontSize="12px">
            Check the <strong>List Activity</strong> to see your data being
            prepared for the dashboard.
          </Typography>
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Open Product Tour Menu',
      content: (
        <ProductTourContent alignItems="center" spacing={1} direction="row">
          <Typography fontSize="12px">
            Click here to open the product tour menu.
          </Typography>
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Explore the Features',
      content: (
        <ProductTourContent spacing={1}>
          <Typography fontSize="12px">
            While your data is being prepared, you can explore NoLimit's
            features through guided product tours.
          </Typography>
          <Typography fontSize="12px">
            <strong>Select a tour below</strong> to <strong>get started</strong>
            , or click <strong>Finish</strong> to <strong>explore later</strong>
            .
          </Typography>
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Finish'
    }
  ]
};
